<template>
  <v-btn
      v-bind="$props"
      small
      tile
      elevation="4"
      rounded
      v-on="$listeners"
  >
    <slot></slot>
  </v-btn>
</template>

<script>
import VBtn from 'vuetify/lib/components/VBtn/'
export default {
  name: 'BaseButton',
  props: VBtn.options.props,
}
</script>